import React from 'react';
import clsx from 'clsx';

export interface CommunicationStatusCardProps {
  /**
   * Pytanie o komunikację z pojazdem
   */
  question: string;
  /**
   * Status komunikacji (pozytywny/negatywny)
   */
  isPositive: boolean;
  /**
   * Tekst odpowiedzi - domyślnie "TAK" lub "NIE"
   */
  answerText?: string;
  /**
   * Dodatkowe klasy CSS
   */
  className?: string;
}

/**
 * Komponent do wyświetlania statusu komunikacji z pojazdem
 *
 * @example
 * ```tsx
 * <CommunicationStatusCard
 *   question="Czy udało się skomunikować z pojazdem"
 *   isPositive={true}
 * />
 * ```
 */
export const CommunicationStatusCard: React.FC<
  CommunicationStatusCardProps
> = ({ question, isPositive, answerText, className }) => {
  const defaultAnswerText = isPositive ? 'TAK' : 'NIE';
  const displayText = answerText || defaultAnswerText;

  return (
    <div
      className={clsx(
        'flex flex-col gap-3 rounded-[15px] border bg-white p-6 shadow-[0px_20px_40px_5px_rgba(166,194,226,0.41)]',
        'w-fit min-w-[300px]',
        {
          'border-green-500': isPositive,
          'border-red-500': !isPositive,
        },
        className,
      )}
    >
      <h3 className="font-archivo text-xl font-bold leading-[1.4] text-[#20262A]">
        {question}
      </h3>

      <div
        className={clsx(
          'flex w-fit items-center justify-center rounded-[50px] px-5 py-2',
          'font-inter text-[15px] font-bold uppercase leading-[1.33]',
          {
            'bg-green-200 text-green-700': isPositive,
            'bg-red-50 text-red-600': !isPositive,
          },
        )}
      >
        {displayText}
      </div>
    </div>
  );
};
